import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode"; // Corrected import

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [role, setRole] = useState(null);
  const [managerId, setManagerId] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (token) {
      const decodedToken = jwtDecode(token);
      setUser(decodedToken);
      if (decodedToken.role === "manager") {
        setRole("manager");
        setManagerId(decodedToken.manager_id); // Assuming the manager_id is in the token
      }
    }
  }, []);
  const [jwtToken, setAuthToken] = useState(() =>
    localStorage.getItem("jwtToken"),
  );
  const [user, setUser] = useState(() =>
    jwtToken ? jwtDecode(jwtToken) : null,
  );

  const login = (token) => {
    setAuthToken(token);
    localStorage.setItem("jwtToken", token);
    setUser(jwtDecode(token));
  };

  const logout = () => {
    setAuthToken(null);
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("userName");
    setUser(null);
    // Navigation will be handled in the component
  };

  useEffect(() => {
    if (jwtToken) {
      setUser(jwtDecode(jwtToken));
    }
  }, [jwtToken]);

  return (
    <AuthContext.Provider
      value={{ jwtToken, user, login, logout, role, managerId }}
    >
      {children}
    </AuthContext.Provider>
  );
};
